import React from 'react'

import { Box, Chip } from "@mui/material"
import { AppRetailerBlock } from "@components"
import { isMainRow } from "Pages/AnalyzersV2/@components/Table/@utils"


export default function websiteColumn(isBrokers, hideIcon = false, tagMainRow = false) {

	return {
		name: 'nameFilter',
		label: isBrokers ? "Providers" : 'Website',
		render: (value, row) => <Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-start",
				gap: .5,
				width: 150,
				position: "sticky",
				top: 0,
				left: 0,
				zIndex: 3,
				pl: hideIcon ? 2 : 0,
			}}>
			<AppRetailerBlock icon={hideIcon ? undefined : row.nameIcon} retailer={value} country={row.nameMarket}/>
			{tagMainRow && isMainRow(row) && <Chip
				label="you"
				size="small"
				color="primary"
				sx={{ height: 18, fontSize: 10, fontWeight: 'bold' }}
			/>}
		</Box>,
	}
}